<template>
    <div class="row mx-0">
        <div class="col-12 position-relative" style="left: 500px">
        </div>
        <div class="col-md-3">
            <all-negotiations />
        </div>
        <div class="col-md-9">
            <refresh-information class="float-right"/>
            <template v-if="fuelGroupSelected !== ''">
                <button 
                    class="btn invisible"
                    :class="[ $breakpoint.smAndDown ? 'btn-icon' : ' mt-2 mb-2']"
                >
                    Used for styling
                </button>
                <div class="modal right fade" v-if="$breakpoint.smAndDown" id="myNegotiation" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <button class="modal-close" data-dismiss="modal" aria-label="Close">
                                <i class="fas fa-lg fa-times"></i>
                            </button> 
                            <negotiation-content />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <negotiation-content />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import breakpoint from '@/mixins/index';

import AllNegotiations from '@/components/Negotiations/seller/AllNegotiations.vue'
import NegotiationContent from '@/components/Negotiations/seller/NegotiationContent.vue'
import RefreshInformation from "@/components/RefreshInformation.vue";

export default {
    mixins: [breakpoint],
    components: {
        AllNegotiations,
        NegotiationContent,
        RefreshInformation
    },
    computed: {
        ...mapState('negotiation', ['fuelGroupSelected']),
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>